import { render, staticRenderFns } from "./Alertas.vue?vue&type=template&id=5efab9b1&"
import script from "./Alertas.vue?vue&type=script&lang=ts&"
export * from "./Alertas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5efab9b1', component.options)
    } else {
      api.reload('5efab9b1', component.options)
    }
    module.hot.accept("./Alertas.vue?vue&type=template&id=5efab9b1&", function () {
      api.rerender('5efab9b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Alertas/Alertas.vue"
export default component.exports